export enum SectionName {
    // section names for component instance
    webtrader = 'webtrader',
    createandsendproductreports = 'createandsendproductreports',
    medicinalproducts = 'medicinalproducts',
    meddra = 'meddra', 
    post = 'post',
    bulkexport = 'bulkexport',
    bulkupdate = 'bulkupdate'
}
